 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML000_COVER from '@/components/xhtml/000_Cover'
 import XHTML001_HALF_TITLE_PAGE from '@/components/xhtml/001_Half_title_page'
 import XHTML002_DEDICATION from '@/components/xhtml/002_Dedication'
 import XHTML002_ABOUT_AUTHOR from '@/components/xhtml/002_About_author'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/Copyright'
 import XHTMLTOC from '@/components/xhtml/toc'
 import XHTML006_IMG from '@/components/xhtml/006_IMG'
 import XHTML006_INTRODUCTION from '@/components/xhtml/006_Introduction'
 import XHTML007_CHAPTER_1 from '@/components/xhtml/007_Chapter_1'
 import XHTML008_CHAPTER_2 from '@/components/xhtml/008_Chapter_2'
 import XHTML009_CHAPTER_3 from '@/components/xhtml/009_Chapter_3'
 import XHTML010_CHAPTER_4 from '@/components/xhtml/010_Chapter_4'
 import XHTML011_CHAPTER_5 from '@/components/xhtml/011_Chapter_5'
 import XHTML012_CHAPTER_6 from '@/components/xhtml/012_Chapter_6'
 import XHTML013_CHAPTER_7 from '@/components/xhtml/013_Chapter_7'
 import XHTML014_CHAPTER_8 from '@/components/xhtml/014_Chapter_8'
 import XHTML015_CHAPTER_9 from '@/components/xhtml/015_Chapter_9'
 import XHTML016_CHAPTER_10 from '@/components/xhtml/016_Chapter_10'
 import XHTML017_APPENDIX from '@/components/xhtml/017_Appendix'
 import XHTML018_APPENDIX from '@/components/xhtml/018_Appendix'
 import XHTML019_APPENDIX from '@/components/xhtml/019_Appendix'
 import XHTML020_BM1 from '@/components/xhtml/020_BM1'
 import XHTML021_BIBLIOGRAPHY from '@/components/xhtml/021_Bibliography'
 import XHTML022_ENDNOTES from '@/components/xhtml/022_Endnotes'
 import XHTML023_PLATE from '@/components/xhtml/023_plate'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/000_Cover",
 			"name" : "xhtml/000_Cover",
 			"component" : XHTML000_COVER
 		},
 		{
 			"path" : "/xhtml/001_Half_title_page",
 			"name" : "xhtml/001_Half_title_page",
 			"component" : XHTML001_HALF_TITLE_PAGE
 		},
 		{
 			"path" : "/xhtml/002_Dedication",
 			"name" : "xhtml/002_Dedication",
 			"component" : XHTML002_DEDICATION
 		},
 		{
 			"path" : "/xhtml/002_About_author",
 			"name" : "xhtml/002_About_author",
 			"component" : XHTML002_ABOUT_AUTHOR
 		},
 		{
 			"path" : "/xhtml/title",
 			"name" : "xhtml/title",
 			"component" : XHTMLTITLE
 		},
 		{
 			"path" : "/xhtml/Copyright",
 			"name" : "xhtml/Copyright",
 			"component" : XHTMLCOPYRIGHT
 		},
 		{
 			"path" : "/xhtml/toc",
 			"name" : "xhtml/toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/006_IMG",
 			"name" : "xhtml/006_IMG",
 			"component" : XHTML006_IMG
 		},
 		{
 			"path" : "/xhtml/006_Introduction",
 			"name" : "xhtml/006_Introduction",
 			"component" : XHTML006_INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/007_Chapter_1",
 			"name" : "xhtml/007_Chapter_1",
 			"component" : XHTML007_CHAPTER_1
 		},
 		{
 			"path" : "/xhtml/008_Chapter_2",
 			"name" : "xhtml/008_Chapter_2",
 			"component" : XHTML008_CHAPTER_2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js